import { useLessonRecurringStore } from './recurring/store'
import { useDisciplineStore } from '../store'
import { useTutorsRecurringAvailabilityApi } from '../../api/lessons/recurring-availability.hook'
import { buildRecurringPayload } from './lesson-recurring'
import { getDefaultTutorFilters } from './lesson-create'

interface LessonRecurringTutorsReturn {
  loadTutors: () => Promise<void>
}

/** Only the newest read may fill the list: an older one still on its way is dropped. */
let latestRead = 0

/**
 * The tutors offered for the recurring schedule, read once when the tutor modal opens, with the filters the panel
 * shows (its defaults until edited). A chosen tutor stays chosen while the new list still has them.
 */
export const useLessonRecurringTutors = (): LessonRecurringTutorsReturn => {
  const route = useRoute()
  const store = useLessonRecurringStore()
  const disciplineStore = useDisciplineStore()

  const loadTutors = async (): Promise<void> => {
    const read = ++latestRead

    store.setTutorsLoading(true)

    const tutors = await useTutorsRecurringAvailabilityApi({
      payload: {
        ...buildRecurringPayload({
          startDate: store.getStartDate,
          days: store.getDays,
          finishType: store.getFinishType,
          occurrences: store.getOccurrences,
          lessons: store.getLessons,
          finishDate: store.getFinishDate,
        }),
        ...(store.getFilters ?? getDefaultTutorFilters(disciplineStore.getDiscipline?.code)),
        discipline_id: Number(route.params.id),
      },
    })

    if (read !== latestRead) return

    const list = tutors ?? []

    store.setTutors(list)
    if (!list.some(tutor => tutor.id === store.getTutorId)) store.setTutorId(null)
    store.setTutorsLoading(false)
  }

  return {
    loadTutors,
  }
}
